import { classNames } from 'libs/react';
import { useMeasure } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import './CollapsibleFormSection.scss';
/**
 * @component CollapsibleFormSection
 * @since 1.0.0
 */
export function CollapsibleFormSection(props) {
    var _a;
    const { style, title, infos } = Object.assign({ style: 'normal' }, props);
    const body = useRef(null);
    const [, , scrollHeight] = useMeasure(body);
    const [expanded, setExpanded] = useState((_a = props.expanded) !== null && _a !== void 0 ? _a : false);
    /**
     * @function onToggle
     * @since 1.0.0
     */
    function onToggle() {
        setExpanded(!expanded);
    }
    const className = classNames('collapsible-form-section', 'collapsible-form-section--' + style, { 'collapsible-form-section--is-expanded': expanded }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "collapsible-form-section-head", onClick: onToggle },
            React.createElement("div", { className: "collapsible-form-section-heading" },
                title && (React.createElement(Text, { className: "collapsible-form-section-title", value: title, style: style })),
                infos && (React.createElement(Text, { className: "collapsible-form-section-infos", value: infos, style: style }))),
            React.createElement(Icon, { className: "collapsible-form-section-arrow", value: "chevron-right" })),
        React.createElement("div", { ref: body, className: "collapsible-form-section-body", style: { '--height': scrollHeight + 'px' } },
            React.createElement("div", { className: "collapsible-form-section-main" }, props.children))));
}
